export enum IRoundFrequency {
	WEEKLY = 'WEEKLY',
	MONTHLY = 'MONTHLY',
	BI_MONTHLY = 'BI_MONTHLY',
	QUARTERLY = 'QUARTERLY',
	TWICE_ANNUAL = 'TWICE_ANNUAL',
	ANNUAL = 'ANNUAL',
}

export const RoundFrequencyValues = {
	[IRoundFrequency.WEEKLY]: {
		count: 1,
		value: 'week',
	},
	[IRoundFrequency.MONTHLY]: {
		count: 1,
		value: 'month',
	},
	[IRoundFrequency.BI_MONTHLY]: {
		count: 2,
		value: 'month',
	},
	[IRoundFrequency.QUARTERLY]: {
		count: 3,
		value: 'month',
	},
	[IRoundFrequency.TWICE_ANNUAL]: {
		count: 6,
		value: 'month',
	},
	[IRoundFrequency.ANNUAL]: {
		count: 1,
		value: 'year',
	},
};
